/**
 * Тут все аккордеоны
 * общий скрипт для всех страниц
 */

// accordion
const acc = document.getElementsByClassName("accordion__header");
for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        let panel = this.nextElementSibling;
        panel.style.display = panel.style.display === "block" ? "none" : "block";
    });
}

/*
Пример использования
```
<div class="accordion">
    <p class="accordion__header">Заголовок 1</p>
    <div class="accordion__panel">
        <div class="legal-info__content">
            <p>Содержимое 1</p>
        </div>
    </div>
    <!-- -->
    <p class="accordion__header">Заголовок 2</p>
    <div class="accordion__panel">
        <div class="legal-info__content">
            <p>Содержимое 2</p>
        </div>
    </div>
</div>
```
*/
